import React from 'react';
import { CallMade, DataObject, Code, MoreHoriz } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CustomIconBtn from 'src/components/UI/button/CustomIconBtn';
import DropButton from 'src/components/UI/button/DropButton';
import { CONSTANTS } from 'src/components/Constants';
import Visibility from '@mui/icons-material/Visibility';
import { ThemeContext } from 'src/store/ContextStore';

const UserTableActions = ({
  status,
  isProband,
  onDeleteClick,
  onViewPatientClick,
  onViewClick,
  onPedigreeViewClick,
  getXMLData,
  getJsonData,
  markAsImported,
  merged
}) => {
  const { theme } = React.useContext(ThemeContext);
  const isEditable = status !== CONSTANTS.user_status.CREATED;
  const isMarkAsImported =
    isEditable && status === CONSTANTS.user_status.SUBMITTED;

  const isSubmitted = status === CONSTANTS.user_status.SUBMITTED;
  const isPedigreeCreated = status === CONSTANTS.user_status.PEDIGREE_CREATED;

  const options = [
    {
      icon: <CallMade fontSize="small" />,
      label: 'View Submission',
      onClick: onViewPatientClick
    },
    {
      icon: <Code fontSize="small" />,
      label: 'XML',
      onClick: getXMLData
    },
    {
      icon: <DataObject fontSize="small" />,
      label: 'JSON (GA4GH standard)',
      onClick: getJsonData
    }
  ];

  const deleteBtn = (
    <Tooltip title="Delete" placement="top" arrow>
      <span>
        <IconButton
          size="small"
          onClick={onDeleteClick}
          sx={{
            color: 'action.active',
            '&:hover': {
              color: '#e41a52',
              backgroundColor: 'rgba(228,26,82,0.08)'
            }
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );

  // When family is merged then we only need to display view submission btn
  if (merged) {
    return (
      <CustomIconBtn
        type="view"
        onClick={onViewClick}
        tooltip="View Submission"
        disabled={status === CONSTANTS.user_status.IMPORTED}
        color={theme?.buttonStyle}
      />
    );
  }

  return (
    <div style={{ minWidth: 200 }}>
      {isSubmitted ? (
        <>
          <CustomIconBtn
            type="view"
            onClick={onViewClick}
            tooltip="View Submission"
            disabled={status === CONSTANTS.user_status.IMPORTED}
          />
          <CustomIconBtn
            type="view-pedigree"
            onClick={onPedigreeViewClick}
            tooltip="View Pedigree"
            color={theme?.buttonStyle}
          />
        </>
      ) : (
        <CustomIconBtn icon={<Visibility fontSize="small" />} disabled={true} />
      )}
      {isPedigreeCreated && (
        <CustomIconBtn
          type="view-pedigree"
          onClick={onPedigreeViewClick}
          tooltip="View Pedigree"
          color={theme?.buttonStyle}
        />
      )}
      {isMarkAsImported && isProband && (
        <CustomIconBtn type="imported" onClick={markAsImported} />
      )}
      {deleteBtn}
      {isEditable && isProband ? (
        <DropButton
          options={options}
          tooltip="More options"
          icon={<MoreHoriz fontSize="small" />}
        />
      ) : (
        <CustomIconBtn icon={<MoreHoriz fontSize="small" />} disabled={true} />
      )}
    </div>
  );
};

export default UserTableActions;
